export default {
	props: {
		form: {required: true, type: Object},
		formLock: {required: true, type: Boolean},
		serverErrors: {required: true, type: Object},
	},
}